import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Unauthorized.css';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-card">
        <div className="unauthorized-icon">🚫</div>
        <h1>Unauthorized Access</h1>
        <p>
          You don't have permission to access this page.
          {user && (
            <>
              <br />
              Your current role: <strong>{user.role}</strong>
            </>
          )}
        </p>
        <div className="unauthorized-actions">
          <button className="button-primary" onClick={() => navigate('/dashboard')}>
            Go to Dashboard
          </button>
          <button className="button-secondary" onClick={logout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
